import { AxiosRequestConfig } from 'axios'
import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import {
  BalanceZoneStoreModel,
  CompanyStoreModel,
  getAppConfigurationValue,
  getUserName
} from '../../../../redux'
import { EnumNivelDesglose } from '../../../Argentia/enums/enumNivelDesglose'
import AxiosInstance from '../../../http-config'
import { EnumCommodity } from '../../../oData/enums'
import { DeleteFileLoadingResponse, FilesLoadingResponse } from '../../model/Files'
import {
  ConsumoRequestModel,
  DownloadFileRequestModel,
  FilesUploadModel,
  InvoiceCodesFileUploadRequestModel,
  InvoiceCodesFileUploadResponseModel,
  TemplateFileModel
} from './models/files'

export class ApiFiles {
  /** @deprecated Migrado a apiFilesUpload (uploadFile?api-version=2.0) */
  FilesLoading = async (
    files: string[] | undefined,
    company: CompanyStoreModel | undefined,
    balanceZone: BalanceZoneStoreModel | undefined
  ): Promise<FilesLoadingResponse[]> => {
    return await AxiosInstance.post(
      `${getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)}/api/FilesLoading`,
      { filesNames: files, balanceZoneID: balanceZone?.id, companyID: company?.id },
      {
        headers: {
          //'x-asr-connection-request-id': connectionId
          'x-asr-user-request-id': getUserName()
        }
      }
    ).then(response => {
      return response.data
    })
  }
}

export const apiFilesUpload = async (
  request: FilesUploadModel
): Promise<FilesLoadingResponse[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/FilesLoading/uploadFile?api-version=2.0`,
    request,
    {
      headers: {
        //'x-asr-connection-request-id': connectionId
        'x-asr-user-request-id': getUserName()
      }
    }
  ).then(response => {
    if (response) {
      return response.data
    } else {
      return []
    }
  })
}

// borra el blob de Storage y la fila de G_DOCUMENTO en un solo paso (no aplica a documentos sin archivo, ej. urls)
export const apiDeleteFilesLoadingDocument = async (
  documentId: number
): Promise<DeleteFileLoadingResponse> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
  return await AxiosInstance.delete(
    `${apiSuffixUrl}/api/FilesLoading/document/${documentId}?api-version=2.0`,
    {
      headers: {
        'x-asr-user-request-id': getUserName()
      }
    }
  ).then(response => response.data)
}

export const apiDownloadProfileTemplate = async (
  profileId: number,
  isSeasonsTemplate: boolean
): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/FilesLoading/DownloadPerfilTemplate/${profileId}?seasonsTemplate=${isSeasonsTemplate}`,
    {
      responseType: 'blob'
    }
  )
}

export const apiDownloadLeadPriceTemplate = async (commodity: EnumCommodity): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  let url = `${apiSuffixUrl}/api/FilesLoading/downloadPriceLeadTemplate/${commodity}`

  return await AxiosInstance.get(url, {
    responseType: 'blob'
  })
}

export const apiDownloadMeasureTemplate = async (
  idLead: number,
  breakdownLevel: EnumNivelDesglose | undefined
): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  let url = `${apiSuffixUrl}/api/FilesLoading/downloadMeasureTemplate/${idLead}`

  if (breakdownLevel !== undefined && breakdownLevel !== null) {
    url += `?nivelDesglose=${breakdownLevel}`
  }

  return await AxiosInstance.get(url, {
    responseType: 'blob'
  })
}

export const apiDownloadProfileSelectionTemplate = async (idLead: number): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  let url = `${apiSuffixUrl}/api/FilesLoading/DownloadProfileSelectionTemplate/${idLead}`

  let config: AxiosRequestConfig = {
    responseType: 'blob',
    timeout: 120000 // Aumentamos el timeout a 2 minutos, tarda un poco el procesamiento de esta plantilla. Si no hacemos esto la llamada suele fallar.
  }

  return await AxiosInstance.get(url, config)
}

export const apiDownloadFiles = async (request: DownloadFileRequestModel): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
  let config: AxiosRequestConfig = {
    responseType: 'blob'
  }

  return AxiosInstance.post(`${apiSuffixUrl}/api/FilesLoading/DownloadFiles`, request, config)
}

export const apiDownloadInvoiceDocument = async (
  invoiceID: number,
  fileExtension: number
): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  let config: AxiosRequestConfig = {
    responseType: 'blob',
    params: {
      fileExtension
    }
  }

  return AxiosInstance.get(
    `${apiSuffixUrl}/api/FilesLoading/downloadFile/invoices/${invoiceID}`,
    config
  )
}

export const apiUploadInvoiceCodesFile = async (
  request: InvoiceCodesFileUploadRequestModel
): Promise<InvoiceCodesFileUploadResponseModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/FilesLoading/uploadInvoiceCodesFile`,
    request
  ).then(response => response.data)
}

export const apiDownloadConsumo = async (request: ConsumoRequestModel): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  let config: AxiosRequestConfig = {
    params: {
      idPuntoSuministro: request.idPuntoSuministro,
      fechaInicio: request.fechaInicio,
      fechaFin: request.fechaFin,
      tipoDocumento: request.tipoDocumento,
      idDocumento: request.idDocumento
    },
    responseType: 'blob'
  }

  return AxiosInstance.get(`${apiSuffixUrl}/api/FilesLoading/downloadConsumo`, config)
}

export const apiDownloadPriceListByQuote = async (idOferta: number): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
  const config: AxiosRequestConfig = {
    responseType: 'blob'
  }

  return AxiosInstance.get(
    `${apiSuffixUrl}/api/FilesLoading/downloadPriceListByQuote/${idOferta}`,
    config
  )
}

export const apiGetTemplates = async (): Promise<TemplateFileModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
  return AxiosInstance.get<TemplateFileModel[]>(`${apiSuffixUrl}/api/FilesLoading/templates`).then(
    response => response.data
  )
}
